/**
 * @typedef {'idle' | 'running' | 'passed' | 'flagged' | 'failedVerdict' | 'errored' | 'unavailable'
 *   | 'outdated'} CheckoutAuditStatus
 */

/** @type {Record<string, CheckoutAuditStatus>} */
export const CHECKOUT_AUDIT_STATUSES = {
  /** Eligible, but no run has produced anything yet. */
  IDLE: 'idle',
  RUNNING: 'running',
  PASSED: 'passed',
  FLAGGED: 'flagged',
  /** The auditor failed the note, as opposed to the review failing. */
  FAILED_VERDICT: 'failedVerdict',
  /** The review itself could not complete. */
  ERRORED: 'errored',
  /** The review could not be attempted, typically with no connection. */
  UNAVAILABLE: 'unavailable',
  /** The note was edited after the result on screen was produced. */
  OUTDATED: 'outdated',
};

/** @typedef {'unavailable' | 'error'} CheckoutAuditFailureReason */

/** @type {Record<string, CheckoutAuditFailureReason>} */
export const CHECKOUT_AUDIT_FAILURE_REASONS = {
  UNAVAILABLE: 'unavailable',
  ERROR: 'error',
};
